import { render, staticRenderFns } from "./SmListRepairPlanUpdatesComment.vue?vue&type=template&id=0377e5e2&"
import script from "./SmListRepairPlanUpdatesComment.vue?vue&type=script&lang=ts&"
export * from "./SmListRepairPlanUpdatesComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
